import React from "react";

export function Skeleton({ className = "", style }) {
    return <div className={`skeleton ${className}`} style={style} aria-hidden="true" />;
}

/** Card-shaped skeleton matching the workspace tile layout. */
export function SkeletonCard({ testId }) {
    return (
        <div data-testid={testId} className="panel-elevated p-5 space-y-3">
            <div className="flex items-center justify-between">
                <Skeleton className="h-3.5 w-20" />
                <Skeleton className="h-4 w-4 rounded-full" />
            </div>
            <Skeleton className="h-6 w-3/4" />
            <Skeleton className="h-3 w-full" />
            <div className="grid grid-cols-3 gap-2 pt-2">
                <Skeleton className="h-12" />
                <Skeleton className="h-12" />
                <Skeleton className="h-12" />
            </div>
        </div>
    );
}

/** Stat-tile skeleton for dashboards. */
export function SkeletonStat({ testId }) {
    return (
        <div data-testid={testId} className="panel-elevated p-5 space-y-3">
            <Skeleton className="h-3 w-24" />
            <Skeleton className="h-8 w-16" />
            <Skeleton className="h-2.5 w-32" />
        </div>
    );
}

/** Generic table-row skeleton. */
export function SkeletonRows({ rows = 6, cols = 5 }) {
    return (
        <div className="space-y-2 p-2">
            {Array.from({ length: rows }).map((_, r) => (
                <div key={r} className="grid gap-3" style={{ gridTemplateColumns: `repeat(${cols}, 1fr)` }}>
                    {Array.from({ length: cols }).map((__, c) => (
                        <Skeleton key={c} className="h-4" style={{ width: c === 1 ? "90%" : "60%" }} />
                    ))}
                </div>
            ))}
        </div>
    );
}
